import { render, staticRenderFns } from "./PhotoStep.vue?vue&type=template&id=1b82bf0e"
import script from "./PhotoStep.vue?vue&type=script&lang=js"
export * from "./PhotoStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports